var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-stick-column",style:({ top: _vm.sticky.top + 'px' }),attrs:{"id":"stick-column"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }